/*
 * @Author: your name
 * @Date: 2021-11-23 20:02:22
 * @LastEditTime: 2025-03-03 01:08:32
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\utils\DashUtils.js
 */
import React from "react"
import {
    BsyUtils
} from "./Utils";
import {
    BsyConfig
} from "../global/BsyConfig";

export function BsyDashUtils() {
    if (window.BsyDashUtils)
        return window.BsyDashUtils;
    return window.BsyDashUtils = {

        CONST: {
            METRIC_COMPARE: {
                year: [{
                    value: "YoYv",
                    text: React.language("dash.field.growthValue.yoy")
                }, {
                    value: "YoYr",
                    text: React.language("dash.field.growthRate.yoy")
                }],
                year_quarter: [{
                    value: "QoQv",
                    text: React.language("dash.field.growthValue.qoq")
                }, {
                    value: "QoQr",
                    text: React.language("dash.field.growthRate.qoq")
                }, {
                    value: "YoYv",
                    text: React.language("dash.field.growthValue.yoy2")
                }, {
                    value: "YoYr",
                    text: React.language("dash.field.growthRate.yoy2")
                }],
                year_month: [{
                    value: "MoMv",
                    text: React.language("dash.field.growthValue.mom")
                }, {
                    value: "MoMr",
                    text: React.language("dash.field.growthRate.mom")
                }, {
                    value: "YoYv",
                    text: React.language("dash.field.growthValue.yoy2")
                }, {
                    value: "YoYr",
                    text: React.language("dash.field.growthRate.yoy2")
                }],
                year_week: [{
                    value: "WoWv",
                    text: React.language("dash.field.growthValue.wow")
                }, {
                    value: "WoWr",
                    text: React.language("dash.field.growthRate.wow")
                }, {
                    value: "YoYv",
                    text: React.language("dash.field.growthValue.yoy2")
                }, {
                    value: "YoYr",
                    text: React.language("dash.field.growthRate.yoy2")
                }],
                year_month_day: [{
                    value: "DoDv",
                    text: React.language("dash.field.growthValue.dod")
                }, {
                    value: "DoDr",
                    text: React.language("dash.field.growthRate.dod")
                }, {
                    value: "WoWv",
                    text: React.language("dash.field.growthValue.wow2")
                }, {
                    value: "WoWr",
                    text: React.language("dash.field.growthRate.wow2")
                }, {
                    value: "MoMv",
                    text: React.language("dash.field.growthValue.mom2")
                }, {
                    value: "MoMr",
                    text: React.language("dash.field.growthRate.mom2")
                }, {
                    value: "YoYv",
                    text: React.language("dash.field.growthValue.yoy2")
                }, {
                    value: "YoYr",
                    text: React.language("dash.field.growthRate.yoy2")
                }]
            },
            METRIC_RATIO_COMPARE: ["YoYr", "QoQr", "MoMr", "WoWr", "DoDr"]
        },
        isRatioMeasure: function (t, e) {
            var i = !1;
            return e && (i = !0),
                t && BsyDashUtils().CONST.METRIC_RATIO_COMPARE.indexOf(t) > -1 && (i = !0),
                i
        },
        getDataFormat: function (t, e) {
            return BsyDashUtils().isRatioMeasure(t, e) ? {
                format: "0.00%",
                formatType: "preset"
            } : {
                format: "0.",
                formatType: "preset"
            }
        },
        getDashStylesExtendStyles: function (t, e) {

            if (BsyUtils.isObjectEmpty(t) && BsyUtils.isObjectEmpty(e)) {
                return null;
            }

            return {
                theme: {
                    ...{},
                    ...(t ? t.theme : {}),
                    ...((t && t.widget) ? t.widget.theme : {}),
                    ...(e ? e.theme : {})
                },
                background: {
                    ...{},
                    ...((t && t.widget) ? t.widget.background : {}),
                    ...((e && !BsyUtils.isObjectEmpty(e.background)) ? e.background : {})
                },
                //$.extend(!0, {}, t && t.widget && t.widget.background, e && !BsyUtils.isObjectEmpty(e.background) && e.background),
                fontSetting: {
                    ...{},
                    ...((t && t.widget) ? t.widget.fontSetting : {}),
                    ...((e && !BsyUtils.isObjectEmpty(e.fontSetting)) ? e.fontSetting : {})
                }
                //$.extend(!0, {}, t && t.widget && t.widget.fontSetting, e && !BsyUtils.isObjectEmpty(e.fontSetting) && e.fontSetting)
            }
        },
        isDashStylesImageBackground: function (t) {
            return "image" === t.background.type
        },
        getDashStylesColor: function (t) {
            return BsyConfig().CONST.DASH_STYLE_COLOR[BsyDashUtils().getDashStylesThemeName(t)].color
        },
        isDashStylesLightTheme: function (t) {
            t = (t = t || {}).theme && t.theme.name;
            return BsyUtils.isEmpty(t) || -1 < BsyConfig().CONST.DASH_STYLE_LIGHT.indexOf(t)
        },
        getDashStylesThemeName: function (t) {
            var e;
            return BsyUtils.isObjectEmpty(t) || (e = t.theme && t.theme.name),
                e = e || BsyConfig().CONST.DASH_STYLE_LIGHT[0]
        },
        getDashStylesBackgroundColor: function (t, e) {
            var i = BsyDashUtils().getDashStylesColor(t),
                e = (t && t.background || {}).color || (BsyDashUtils().isDashStylesLightTheme(t) ? "" : i[e || 0]);
            return BsyDashUtils().isDashStylesBackgroundColor(t) ? e : ""
        },
        getDashStylesTitleColor: function (t) {
            var e = t && t.fontSetting,
                t = BsyDashUtils().isDashStylesDarkTheme(t) ? BsyConfig().CONST.DASH_STYLE_DARK_COLOR[0] : "";
            return e && e.titleColor || t
        },
        isDashStylesBackgroundColor: function (t) {
            return !!BsyUtils.isObjectEmpty(t) || (!!BsyUtils.isObjectEmpty(t.background) || (!!BsyUtils.isObjectEmpty(t.background.image) || !BsyDashUtils().isDashStylesImageBackground(t)))
        },
        setDashStylesBackground: function (t, e, i) {
            var a = t && t.background || {},
                n = a.type || "color",
                s = BsyDashUtils().getDashStylesBackgroundColor(t, i),
                o = a.position || "center",
                r = a.image;
            switch (n) {
                case "color":
                    e.css({
                        background: s
                    });
                    break;
                case "image":
                    if (BsyUtils.isObjectEmpty(r)) {
                        e.css({
                            background: s
                        });
                        break
                    }
                    var l = {
                        background: "none",
                        "background-image": "url(" + r + ")"
                    };
                    switch (o) {
                        case "center":
                            l = {
                                ...l,
                                "background-size": "cover",
                                "background-position": "center"
                            }

                            break;
                        case "stretch":
                            l = {
                                ...l,
                                "background-size": "100% 100%"
                            }
                            break
                        default: {

                        }
                    }
                    e.css(l)
                    break;
                default: {

                }
            }
        },
        isCustomSort: function (t) {
            return BsyUtils.isArray(t)
        },
        getDashStylesCardName: function (t) {
            var e;
            return BsyUtils.isObjectEmpty(t) || (e = t.theme && t.theme.cardName),
                e = e || "preset_metric_1"
        },
        isDashStylesDarkTheme: function (t) {
            var e = !1;
            return BsyUtils.isObjectEmpty(t) || (t = t.theme && t.theme.name,
                    e = -1 < BsyConfig().CONST.DASH_STYLE_DARK.indexOf(t)),
                e
        },
        checkThresholdAlert: function (t, e, i) {
            var a = !1;
            return !BsyUtils.isObjectEmpty(e) && BsyUtils.isNumber(t) && BsyUtils.forEach(i, function (i, n) {
                    if (n.enable) {
                        var s = n.cond,
                            o = s.value && s.value[0];
                        if (s.field === e.tag)
                            switch (s.method) {
                                case "lt":
                                    if (t < o)
                                        return a = !0,
                                            !1;
                                    break;
                                case "lte":
                                    if (t <= o)
                                        return a = !0,
                                            !1;
                                    break;
                                case "eq":
                                    if (t === o)
                                        return a = !0,
                                            !1;
                                    break;
                                case "gt":
                                    if (t > o)
                                        return a = !0,
                                            !1;
                                    break;
                                case "gte":
                                    if (t >= o)
                                        return a = !0,
                                            !1
                                    break
                                default: {

                                    break;
                                }
                            }
                    }
                }),
                a
        },
        getFilterByComponent: function (e, i, a) {
            if (!i)
                return null;
            var n = i.fields[0],
                s = {};
            switch (s.method = i.method || BsyUtils.getDashDefaultFilterMethod(n && n.type),
                s.fields = i.fields,
                s.triggers = i.triggers,
                n && n.type) {
                case "text":
                case "radiogroup":
                case "combo":
                case "sn":
                    s = {
                        ...s,
                        ...BsyDashUtils()._getComboCheckFilter("text", a)
                    }
                    // t.extend(s, BsyDashUtils()._getComboCheckFilter("text", a));
                    break;
                case "textarea":
                    s.type = "textarea";
                    var o = a && a.items ? a.items[0] : a && a.value;
                    s.value = o ? BsyUtils.makeArray(o) : [];
                    break;
                case "combocheck":
                case "checkboxgroup":
                    s = {
                        ...s,
                        ...BsyDashUtils()._getComboCheckFilter("combocheck", a)
                    }

                    // t.extend(s, BsyDashUtils()._getComboCheckFilter("combocheck", a));
                    break;
                case "number":
                    s.type = "number"
                    a && (s.value = BsyUtils.isEmpty(a.value) ? [a.min, a.max] : [a.value]);
                    break;
                case "datetime":
                    s.type = "datetime";
                    var r = "yyyy-MM-dd";
                    switch (i.type) {
                        case "datetime_filter": {
                            r = "yyyy-MM-dd HH:mm:ss";
                            break;
                        }

                        case "datemonth_filter": {
                            r = "yyyy-MM";
                            break;
                        }

                        case "dateyear_filter": {
                            r = "yyyy";
                            break;
                        }

                        default: {
                            break
                        }
                    }
                    // var r = "datetime_filter" === i.type ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
                    a && a.value ? s.value = [BsyUtils.date2Str(new Date(a.value), r)] : a && a.mode ? s.value = [a] : s.value = [a && a.min ? BsyUtils.date2Str(new Date(a.min), r) : null, a && a.max ? BsyUtils.date2Str(new Date(a.max), r) : null];
                    break;
                case "address":
                case "location":
                    s.type = "address"
                    s.value = a ? [a.province, a.city, a.district] : [];
                    break;
                case "user":
                case "usergroup":
                case "dept":
                case "deptgroup":
                    s = {
                        ...s,
                        ...BsyDashUtils()._getComboCheckFilter(n.type, a)
                    }
                    break;
                case "flowstate":
                    s.type = "flowstate"
                    s.value = BsyUtils.makeArray(a && a.items ? a.items[0] : a && a.value);
                    break;
                case "upload":
                case "image":
                    s.type = "file_list";
                    break;
                case "signature":
                    s.type = "signature"
                    break;
                default: {
                    break;
                }
            }
            return s
        },
        _getComboCheckFilter: function (e, i) {
            var a = i && i.items || i && i.value;
            return {
                type: e,
                hasEmpty: !(!i || !i.hasEmpty),
                value: a ? BsyUtils.makeArray(a) : []
            }
        },
        getFilterByWidgetName: function (e, i, a) {
            var n = [];
            BsyUtils.forEach(i, function (i, s) {
                s.triggers && s.method && BsyUtils.forEach(s.triggers, function (i, o) {
                    if (o === e) {
                        var r = a[e].forms[0];
                        BsyUtils.forEach(s.fields, function (e, i) {
                            if (i.form === r) {
                                var a = {
                                    ...{},
                                    ...s,
                                    entryId: i.form,
                                    field: i.field
                                };

                                if (i.subform) {
                                    a = {
                                        ...a,
                                        subform: i.subform,
                                        subField: i.subField
                                    }
                                    a.field = null
                                } else {
                                    a.subform = null
                                    a.subField = null
                                }

                                // i.subform ? (t.extend(a, {
                                //             subform: i.subform,
                                //             subField: i.subField
                                //         }),
                                //         a.field = null) : (a.subform = null,
                                //         a.subField = null),
                                n.push(a)
                                return !1
                            }
                        })
                        return !1
                    }
                })
            })
            return BsyUtils.getValidFilters({
                cond: n
            }).cond
        },
        getDashStyle: (style, dashClass) => {
            let dashclass = ('.' + dashClass) || ''
            let res = `.bsy-dash${dashclass}{`;
            let background = style.background || {};
            style.theme = style.theme || {};
            if (!background) {
                return ''
            }
            switch (background.type) {
                case "color": {
                    res += "\nbackground:" + background.color;
                    break;
                }
                default: {
                    if (background.position === "stretch") {
                        res += "\nbackground:url('" + background.image + "') 0% 0% / 100% 100%";
                        // this.element.css("background",'url("' + background.image + '") 0% 0% / 100% 100%');
                    } else {
                        res += "\nbackground:url('" + background.image + "') center center / cover";
                        // this.element.css("background",'url("' + background.image + '") center center / cover');
                    }
                    break;
                }
            }
            res += `\n}`

            if (style.theme.name === "preset_style_dark_1" || style.theme.name === "preset_style_dark_3") {
                res += `.BsyDashView .dashView-header,.BsyEntryView .dashView-header{
                    color:#ffffff;
                    border-color:#29314c !important;
                    background-color:#29314c !important;
                }
                .BsyDashView .dashView-header .dashView-funBtn .dash-filter-rel .BsySelect span,.BsyEntryView .dashView-header .dashView-funBtn .dash-filter-rel .BsySelect span{
                    color:#ffffff;
                    width: auto!important;
                    padding: 0;
                    letter-spacing: .67px;
                    font-weight: 500;
                }
                .BsyDashView .dashView-header .dashView-funBtn .dash-filter-rel .BsySelect .iconSelect,.BsyEntryView .dashView-header .dashView-funBtn .dash-filter-rel .BsySelect .iconSelect{
                    padding: 0;
                }
                .BsyDashView .dashView-header .dashView-funBtn .dash-filter-rel .BsySelect .iconSelect i,.BsyEntryView .dashView-header .dashView-funBtn .dash-filter-rel .BsySelect .iconSelect i{
                    color:#ffffff;
                }
                `;
            }



            if (style.theme.highLightColor) {
                res += `
                    .block-content .bsy-dash-head .showText span, 
                    .block-content .bsy-dash-head .iconSelect:hover i, 
                    .block-content .bsy-dash-cont .showText:hover i,
                    .block-content .bsy-dash-cont .bsy-datetime:hover i
                    .block-content .data-table  .showText span, 
                    .block-content .data-table  .iconSelect:hover i, 
                    .block-content .data-table  .showText:hover i,
                    { 
                        color:${style.theme.highLightColor}  !important;
                    }

                    .block-content .bsy-dash-cont .showText:hover,
                    .block-content .bsy-dash-cont .showText.open,
                    .block-content .data-table .showText:hover,
                    .block-content .data-table .showText.open,
                    .block-content .bsy-dash-cont .bsy-multi-text:hover,
                    .block-content .bsy-dash-cont .bsy-multi-text:hover .text-input:hover,
                    .block-content .bsy-dash-cont .bsy-text input:hover,
                    .block-content .bsy-dash-cont .bsy-text input:focus,
                   
                    {
                        border-color:${style.theme.highLightColor}  !important;
                    }

                    .block-content .bsy-dash-cont .selectList .item:hover {
                        background-color:${BsyUtils.hexToRGBAStr(style.theme.highLightColor, 0.3)}  !important;
                    }
                    

                    .block-content .bsy-datepicker .day.today.selected,
                    .block-content .bsy-datepicker .day.selected
                    {
                        border: 1px solid ${style.theme.highLightColor}  !important;
                        background-color:${style.theme.highLightColor}  !important;
                    }
                    .block-content .bsy-datepicker .day:hover,
                    .block-content .bsy-datepicker .prevm:hover,
                    .block-content .bsy-datepicker .nextm:hover,
                    .block-content .bsy-datepicker .title:hover
                     
                    {
                        border: 1px solid ${BsyUtils.hexToRGBAStr(style.theme.highLightColor, 0.2)}  !important;
                        background-color:${BsyUtils.hexToRGBAStr(style.theme.highLightColor, 0.2)}  !important;
                    }

                    .${style.theme.name}.bsy-datepicker .day.today.selected,
                    .${style.theme.name}.bsy-datepicker .day.selected,
                    .${style.theme.name}.bsy-datepicker .month.selected,
                    .${style.theme.name}.bsy-datepicker .year.selected
                    {
                        border: 1px solid ${style.theme.highLightColor}  !important;
                        background-color:${style.theme.highLightColor}  !important;
                    }
                    .${style.theme.name}.bsy-datepicker .day:hover,
                    .${style.theme.name}.bsy-datepicker .month:hover,
                    .${style.theme.name}.bsy-datepicker .year:hover,
                    .${style.theme.name}.bsy-datepicker .prevm:hover,
                    .${style.theme.name}.bsy-datepicker .nextm:hover,
                    .${style.theme.name}.bsy-datepicker .prevy:hover,
                    .${style.theme.name}.bsy-datepicker .nexty:hover,
                    .${style.theme.name}.bsy-datepicker .title:hover
                     
                    {
                        border: 1px solid ${BsyUtils.hexToRGBAStr(style.theme.highLightColor, 0.2)}  !important;
                        background-color:${BsyUtils.hexToRGBAStr(style.theme.highLightColor, 0.2)}  !important;
                    }
                `
            }

            return res;
        },
        getDashStylesDefault: (t) => {
            t = t || BsyConfig().CONST.DASH_STYLE_LIGHT[0];
            var e = -1 < BsyConfig().CONST.DASH_STYLE_DARK.indexOf(t) ? BsyConfig().CONST.DASH_STYLE_DARK_COLOR : BsyConfig().CONST.DASH_STYlE_LIGHT_COLOR,
                i = BsyConfig().CONST.DASH_STYLE_COLOR[t],
                a = {
                    theme: {
                        name: t,
                        highLightColor: i.highLightColor
                    },
                    background: {
                        type: "color",
                        color: i.color[0]
                    },
                    widget: {
                        theme: {
                            color: i.tableColor,
                            icon: 1
                        },
                        background: {
                            type: "color",
                            color: i.color[1]
                        },
                        fontSetting: {
                            titleColor: e[0],
                            headColor: e[1],
                            textColor: e[0],
                            textAlign: "default"
                        }
                    }
                };
            switch (t) {
                case "preset_style_light_1":
                    a.theme = {
                        ...a.theme,
                        palette: "preset_1",
                        gradation: "preset_map_1"
                    };
                    a.widget.theme = {
                        ...a.widget.theme,
                        cardName: "preset_metric_1"
                    }
                    // $.extend(a.theme, {
                    //     palette: "preset_1",
                    //     gradation: "preset_map_1"
                    // })
                    // $.extend(a.widget.theme, {
                    //     cardName: "preset_metric_1"
                    // });
                    break;
                case "preset_style_dark_1":
                    a.theme = {
                        ...a.theme,
                        palette: "preset_8",
                        gradation: "preset_map_1"
                    };
                    a.widget.theme = {
                        ...a.widget.theme,
                        cardName: "preset_metric_5"
                    }
                    a.widget.fontSetting = {
                        ...a.widget.fontSetting,
                        valueColor: "#31d7ff"
                    }


                    // $.extend(a.theme, {
                    //         palette: "preset_8",
                    //         gradation: "preset_map_1"
                    //     }),
                    //     $.extend(a.widget.theme, {
                    //         cardName: "preset_metric_5"
                    //     }),
                    //     $.extend(a.widget.fontSetting, {
                    //         valueColor: "#31d7ff"
                    //     });
                    break;
                case "preset_style_dark_2":

                    a.theme = {
                        ...a.theme,
                        palette: "preset_2",
                        gradation: "preset_map_2"
                    };
                    a.widget.theme = {
                        ...a.widget.theme,
                        cardName: "preset_metric_3"
                    }
                    a.widget.fontSetting = {
                        ...a.widget.fontSetting,
                        valueColor: "#f1b030"
                    }

                    // $.extend(a.theme, {
                    //         palette: "preset_2",
                    //         gradation: "preset_map_2"
                    //     }),
                    //     $.extend(a.widget.theme, {
                    //         cardName: "preset_metric_3"
                    //     }),
                    //     $.extend(a.widget.fontSetting, {
                    //         valueColor: "#f1b030"
                    //     });
                    break;
                case "preset_style_dark_3":


                    a.theme = {
                        ...a.theme,
                        palette: "preset_8",
                        gradation: "preset_map_7"
                    };
                    a.widget.theme = {
                        ...a.widget.theme,
                        cardName: "preset_metric_5"
                    }
                    a.widget.fontSetting = {
                        ...a.widget.fontSetting,
                        valueColor: "#35e8b3"
                    }
                    a.background = {
                        ...a.background,
                        type: "image",
                        image: window.rootDirectroy +"/template/formreport/static/css/resources/images/theme-4-bg.png"
                    }

                    a.widget.background = {
                        ...a.widget.background,
                        type: "image",
                        image: window.rootDirectroy +"/template/formreport/static/css/resources/images/block-bg.png",
                        position: "center",
                        color: "transparent"
                    }

                    // $.extend(a.widget.theme, {
                    //         cardName: "preset_metric_5"
                    //     }),
                    //     $.extend(a.widget.fontSetting, {
                    //         valueColor: "#35e8b3"
                    //     }),
                    //     $.extend(a.theme, {
                    //         palette: "preset_8",
                    //         gradation: "preset_map_7"
                    //     }),
                    // $.extend(a.background, {
                    //         type: "image",
                    //         image: "/template/formreport/static/css/resources/images/theme-4-bg.png"
                    //     }),
                    //     $.extend(a.widget.background, {
                    //         type: "image",
                    //         image: "/template/formreport/static/css/resources/images/block-bg.png",
                    //         position: "center"
                    //     }),
                    //     a.widget.background.color = "transparent"
                    break;
                default:
            }
            return a
        },
        getTableInlineStyle: (styleId, styles, type, customClass) => {

            if (BsyUtils.isObjectEmpty(styles)) {
                return "";
            }

            let styleName = styles.theme.name;


            let res = `.${styleId}.${type}>.bsy_dash_block{`;
            let background = styles.background;
            switch (background.type) {
                case "color": {
                    res += "\nbackground:" + background.color;
                    break;
                }
                default: {
                    if (background.position === "stretch") {
                        res += "\nbackground:url('" + background.image + "') 0% 0% / 100% 100%";

                    } else {
                        res += "\nbackground:url('" + background.image + "') center center / cover";

                    }
                    break;
                }
            }
            res += `\n}`

            // .${styleId}.${type} .BsySelect .icon-bsy-xiala{
            //     color: {highLightColor} 
            // }
            // .${styleId}.${type} .bsy-datetime .bsy-trigger-btn{
            //     color: {highLightColor} 
            // }


            var inlineStyle = res;
            let header = `.${styleId}.${type} .block-head `;
            let body = `.${styleId}.${type} .block-content `;

            if (customClass) {
                header = `.${customClass} ` + header;
                body = `.${customClass} ` + body;
            }

            inlineStyle += ` ${header} .block-title {
                color:${styles.fontSetting.titleColor}
            }`;
            inlineStyle += `.t-block-title {
                color:${styles.fontSetting.titleColor}
            }`;
            inlineStyle += ` ${body} .bsy-cond-label {
                color:${styles.fontSetting.titleColor}
            }`;

            inlineStyle += ` ${body} .cond-method .showText span {
                color: {highLightColor}
            }`;
            inlineStyle += ` ${body} .cond-method .showText .iconSelect i {
                color: {highLightColor}
            }`;
            inlineStyle += ` ${body} .cond-method .showText:hover .iconSelect i {
                color: {highLightColor}
            }`;

            inlineStyle += `
                .preset_style_dark_1.bsy-msg-bubble .bsy-trigger-pane .item:hover, 
                .preset_style_dark_3.bsy-msg-bubble .bsy-trigger-pane .item:hover {
                    background: {highLightColor} !important;
                }
               .preset_style_dark_1.bsy-msg-bubble .bsy-trigger-pane .item.select, 
                .preset_style_dark_3.bsy-msg-bubble .bsy-trigger-pane .item.select {
                    background: {highLightColor} !important;
                }
                `;

            inlineStyle = inlineStyle.replace(RegExp("\{highLightColor\}", "g"), styles.theme.highLightColor + " !important;");

            switch (type) {
                case "filter_btn": {
                    inlineStyle += ` ${body} ` + 
                        ".bsy-dash-button,.t-up-dowm{" +
                        "    background: {highLightColor}" +
                        "    border-color: {highLightColor}" +
                        "}"
                    inlineStyle = inlineStyle.replace(RegExp("\{highLightColor\}", "g"), styles.theme.highLightColor + " !important;");
                    break;
                }
                case "metric_table": {
                    inlineStyle += ` ${body} ` + 
                        " .bsy-dash-metric-table.no-dimension .sum-val{" +
                        "    color: {valueColor}" +
                        "}";
                    styles.fontSetting.valueColor && (inlineStyle += body + " .bsy-dash-metric-table.no-dimension.preset_metric_1 .content-wrapper .inner-content .sum:hover{background-color:transparent}")
                    inlineStyle = inlineStyle.replace(RegExp("\{valueColor\}", "g"), styles.fontSetting.valueColor + " ;");
                    break;
                }


                case "data_table":
                case "pivot_table":
                default: {
                    inlineStyle += ` ${body} .art-table-wrapper {
                        --cell-border-vertical: 1px solid {theme-color-08} ;
                        --cell-border-horizontal: 1px solid {theme-color-08} ;
                    }\n`
                    inlineStyle += ` ${body} .chart-data-border {
                        --cell-border-vertical: 1px solid {theme-color-08} ;
                        --cell-border-horizontal: 1px solid {theme-color-08} ;
                    }\n`
                    inlineStyle += ` ${body} .art-sticky-scroll {
                        border-bottom: 1px solid {theme-color-08} ;
                    }\n`

                    // inlineStyle += ` ${body}  .art-table-body {
                    //     border-bottom: 1px solid {theme-color-08} 
                    // }\n`
                    
                    inlineStyle += ` ${body}  .art-table-sticky-row-header {
                        border-bottom: 1px solid {theme-color-08} 
                    }\n`
                    inlineStyle += ` ${body}  .art-table-sticky-menu {
                        border-bottom: 1px solid {theme-color-08} 
                    }\n`

                    inlineStyle += ` ${body}  {
                        border-color: {theme-color-08} 
                    }\n`

                    inlineStyle += ` ${body} .art-table-header {
                        background: transparent 
                    }\n`

                    inlineStyle += ` ${body} .art-table-body {
                        background: transparent 
                    }\n`


                    inlineStyle += ` ${body}  .art-table thead{
                        background-color: {background}
                    }\n`

                    inlineStyle += ` ${body}  .art-table thead th{
                        color: {headColor} 
                        background-color: {theme-color} 
                        background-clip: padding-box; 
                        /*{textAlign}*/
                    }\n`

                    inlineStyle += ` ${body}  .art-table thead th .cell-sort-header .sort-icon{
                        background-color: {theme-color} 
                    }\n`

                    // if(type == "pivot_table") {
                    //     inlineStyle += ` ${body}  .art-table thead th{
                    //         {textAlign}
                    //     }\n`
                    //     if (styles.fontSetting.textAlign == 'right') {
                    //         inlineStyle += ` ${body}  .art-table thead th .cell-sort-header{
                    //             justify-content:flex-end !important;
                    //             padding-right: 18px !important;
                    //         }\n`
                    //     }
                    //     if (styles.fontSetting.textAlign == 'center') {
                    //         inlineStyle += ` ${body}  .art-table thead th .cell-sort-header{
                    //             justify-content:center !important;
                            
                    //         }\n`
                    //     }
                    // } 
 

                    inlineStyle += ` ${body}  .art-table tbody{
                        background: {background}
                    }\n`

                    inlineStyle += ` ${body}  tr.art-table-row.odd td{
                        background: {theme-color-02}
                    }\n`


            
                    inlineStyle += ` ${body}  tr.art-table-row.odd .BsyCheckBox{
                        background: {theme-color-02}
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.even .BsyCheckBox{
                        background: {theme-color-005}
                    }\n`
             
         

                    inlineStyle += ` ${body}  tr.art-table-row.even td{
                        background: {theme-color-005}
                    }\n`


         
                    let background = "";
                    if(styles.background && styles.background.type == 'color') {
                        background = styles.background.color;
                    }
                    switch(styleName) {
                        case "preset_style_light_1":{
                            if(styles.background && styles.background.type == 'image') {
                                background = '#fff ';
                            }
                            break;
                        }
                        case "preset_style_dark_1":{
                            if(styles.background && styles.background.type == 'image') {
                                background = 'rgb(17, 17, 33)';
                            }
                            break;
                        }
                        case "preset_style_dark_2":{
                            if(styles.background && styles.background.type == 'image') {
                                background = '#fff ';
                            }
                            break;
                        }
                        case "preset_style_dark_3":{
                            if(styles.background && styles.background.type == 'image') {
                                background = '#111121';
                            }
                            break;
                        }
                        default:{
                            if(styles.background && styles.background.type == 'image') {
                                background = '#fff ';
                            }
                            break;
                        }
                    }
                    
                    inlineStyle += ` ${body}  tr.art-table-row.even td.lock-right{
                        background: ${background}  !important;
              
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.odd td.lock-right{
                        background: ${background}  !important;
                    
                    }\n`
                    inlineStyle += ` ${body}.scroll-background tr.art-table-row.even td.lock-left{
                        background: ${background}  !important;
                   
                    }\n`
                    
                    inlineStyle += ` ${body}.scroll-background tr.art-table-row.odd td.lock-left{
                        background: ${background}  !important;
                    
                    }\n`
                    inlineStyle += ` ${body} tr.art-table-row.even td.lock-left{
                        background: ${background}  !important;
                   
                    }\n`
                    
                    inlineStyle += ` ${body} tr.art-table-row.odd td.lock-left{
                        background: ${background}  !important;
                    
                    }\n`

                    inlineStyle += ` ${body}  tr.art-table-row.odd td.lock-right.last{
                        background: transparent !important;
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.even td.lock-right.last{
                        background: transparent !important;
                    }\n`

                    inlineStyle += ` ${body}  tr.art-table-row.even td.lock-right .bsy-td-background{
                        background: {theme-color-005}
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.odd td.lock-right .bsy-td-background{
                        background: {theme-color-02}
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.even td.lock-left .bsy-td-background{
                        background: {theme-color-005}
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.odd td.lock-left .bsy-td-background{
                        background: {theme-color-02}
                    }\n`

                                
                    inlineStyle += ` ${body}  tr.art-table-row.hover{
                        background:transparent;
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.hover td{
                        background: {hoverColor}
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.hover td.lock-left .bsy-td-background{
                        background: {hoverColor}
                    }\n`
                    inlineStyle += ` ${body}  tr.art-table-row.hover td.lock-right .bsy-td-background{
                        background: {hoverColor}
                    }\n`
                    

                    inlineStyle += ` ${body}  tr.art-table-row.hover td .background-mask{
                        background: {hoverColor}
                    }\n`


                    // if(styleName !== "preset_style_light_1") {
                        // inlineStyle += ` ${body}  tr.art-table-row.hover td .BsyCheckBox{
                        //     background: {hoverColor}
                        // }\n`
                    // }

       

                    inlineStyle += ` ${body}  tr.art-table-row td .row-order{
                        color: {textColor}
                    }\n`


                    //冻结项目 旁边线
                    inlineStyle += ` ${body}  .art-lock-shadow{
                        border-color: {theme-color-08}
                    }\n`


                    //表头边框线
                    inlineStyle += ` ${body}  .art-table-header-row th{
                        border-color: transparent;
                    }\n`

                    //表主体
                    inlineStyle += ` ${body}  td.art-table-cell {
                        color: {textColor}
                        border-color: {theme-color-08}
                        {textAlign}
                        background: transparent !important;
                    }\n`
                    // inlineStyle += ` ${body}  td.art-table-cell .number-value{
                    //     {textAlign}
                    // }\n`

                    inlineStyle += ` ${body} .BsyTurnPage .BsySelect .showText {
                        background:transparent;
                    }\n`
                    inlineStyle += ` ${body} .BsyTurnPage .BsySelect .showText i {
                        color: {highLightColor}
                    }\n`

                    inlineStyle += ` ${body} .BsyTurnPage .turn-btn i {
                        color: {highLightColor}
                    }\n`

                    inlineStyle += ` ${body} .BsyTurnPage .turn-btn.disabled  {
                        border: 1px solid {theme-color-08}
                        background: transparent;
                    }\n`

                    inlineStyle += ` ${body} .BsyTurnPage .turn-btn.disabled i {
                        color: {theme-color-08}
                    }\n`

                    // inlineStyle += ` ${body} .bsy-row-height-combo {
                    //     border: 1px solid {highLightColor}
                    // }\n`

                    // inlineStyle += ` ${body} .bsy-row-height-combo i {
                    //     color: {highLightColor}
                    // }\n`

                    if (type)
                        inlineStyle = inlineStyle.replace(RegExp("fui_dash_pivottable", "g"), type);
                    //{theme-color-08} 透明度 0.8
                    //{theme-color-03} 透明度 0.3
                    //{theme-color-005} 透明度 0.05

                    //{textColor}
                    //{headColor}
                    //{textAlign} textAlign: "center"

                    inlineStyle = inlineStyle.replace(RegExp("\{highLightColor\}", "g"), styles.theme.highLightColor + " ;");
                    inlineStyle = inlineStyle.replace(RegExp("\{theme-color\}", "g"), styles.theme.color + ";");


                    inlineStyle = inlineStyle.replace(RegExp("\{theme-color-08\}", "g"), BsyUtils.hexToRGBAStr(styles.theme.color, 0.8) + ";");
                    inlineStyle = inlineStyle.replace(RegExp("\{theme-color-02\}", "g"), BsyUtils.hexToRGBAStr(styles.theme.color, 0.2) + " !important;");

                    inlineStyle = inlineStyle.replace(RegExp("\{hoverColor\}", "g"), BsyUtils.hexToRGBAStr(styles.theme.highLightColor, 0.3) + " !important;");
                    inlineStyle = inlineStyle.replace(RegExp("\{theme-color-005\}", "g"), BsyUtils.hexToRGBAStr(styles.theme.color, 0.05) + " !important;");

                    //文字颜色
                    inlineStyle = inlineStyle.replace(RegExp("\{textColor\}", "g"), styles.fontSetting.textColor + ";");
                    //表头颜色
                    inlineStyle = inlineStyle.replace(RegExp("\{headColor\}", "g"), styles.fontSetting.headColor + ";");
                    if (styles.background.type == "color") {
                        inlineStyle = inlineStyle.replace(RegExp("\{background\}", "g"), styles.background.color + " !important;");
                    } else {
                        inlineStyle = inlineStyle.replace(RegExp("\{background\}", "g"), "transparent;");
                    }
                    inlineStyle = inlineStyle.replace(RegExp("\{hoverColor\}", "g"), styles.background.color + ";");


                    //对齐方式
                    if (styles.fontSetting.textAlign != "default") {
                        inlineStyle = inlineStyle.replace(RegExp("\{textAlign\}", "g"), 'text-align: ' + styles.fontSetting.textAlign + (type == 'pivot_table') ? ";" : " !important;");
                    } else {
                        inlineStyle = inlineStyle.replace(RegExp("\{textAlign\}", "g"), '');
                    }
                    break;
                }
            }

            return inlineStyle;
        },
        getFilterRelyFilter: function (a, t) {
            var n = [],
                e = t[a],
                s = !BsyUtils.isObjectEmpty(e && e.fields) && e.fields[0].form;
            BsyUtils.forEach(t, function (t, e) {
                var i;
                // e && e.rely && -1 < e.rely.indexOf(a) && (BsyUtils.forEach(e.fields, function(t, e) {
                //     if (e.form === s)
                //         return i = e,
                //         !1
                // }),
                // i && (e = $.extend({}, e, {
                //     entryId: i.form,
                //     field: i.field
                // }),
                // i.subform ? ($.extend(e, {
                //     subform: i.subform,
                //     subField: i.subField
                // }),
                // e.field = void 0) : (e.subform = void 0,
                // e.subField = void 0),
                // n.push(e)))

                if (e && e.rely && -1 < e.rely.indexOf(a)) {
                    BsyUtils.forEach(e.fields, function (t, e) {
                        if (e.form === s)
                            return i = e,
                                !1
                    })
                    if (i) {
                        e = {
                            ...e,
                            entryId: i.form,
                            field: i.field
                        }

                        if (i.subform) {
                            e = {
                                ...e,
                                subform: i.subform,
                                subField: i.subField
                            }
                            e.field = null;
                        } else {
                            e.subform = null;
                            e.subField = null;
                        }
                        // i.subform ? ($.extend(e, {
                        //     subform: i.subform,
                        //     subField: i.subField
                        // }),
                        // e.field = void 0) : (e.subform = void 0,
                        // e.subField = void 0),
                        n.push(e)
                    }
                }
            })

            return BsyUtils.getValidFilters({
                cond: n,
                rel: BsyConfig().CONST.FILTER_RELATION.AND
            })
        },
    }
}